import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import api, { errText } from "@/lib/api";
import { toast } from "sonner";
import { tamanoValido, RANGO } from "@/lib/validacion";

function Editable({ value, onSave, testid }) {
  const [editando, setEditando] = useState(false);
  const [val, setVal] = useState(value || "");
  if (editando) {
    return (
      <input
        autoFocus
        className="bg-transparent border-b border-dorado text-gris outline-none text-center"
        value={val}
        onChange={(e) => setVal(e.target.value)}
        onBlur={() => { setEditando(false); if (val !== value) onSave(val); }}
        onKeyDown={(e) => { if (e.key === "Enter") e.target.blur(); }}
        data-testid={`edit-${testid}`}
      />
    );
  }
  return (
    <span onClick={() => setEditando(true)} className="cursor-pointer border-b border-transparent hover:border-borde transition-colors" data-testid={`ver-${testid}`}>
      {value || "—"}
    </span>
  );
}

export default function Bienvenida() {
  const nav = useNavigate();
  const { user, empresa, setEmpresa } = useAuth();

  const guardar = async (campo, valor) => {
    if (campo === "tamano" && !tamanoValido(valor)) { toast.error(RANGO.personas.msg); return; }
    try {
      const { data } = await api.patch("/empresa/mia", { [campo]: valor });
      setEmpresa(data.empresa);
    } catch (e) { toast.error(errText(e)); }
  };

  return (
    <div className="min-h-screen bg-negro flex flex-col items-center justify-center px-6 text-center">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, ease: "easeOut" }}>
        <h1 className="titulo text-[42px] leading-tight mb-1">Hola {user?.nombre}.</h1>
        <h1 className="titulo text-[42px] leading-tight mb-10">Te estábamos esperando.</h1>

        <div className="text-gris text-lg mb-4 flex items-center justify-center gap-2 flex-wrap">
          <Editable value={empresa?.rubro} onSave={(v) => guardar("rubro", v)} testid="rubro" />
          <span className="text-borde">·</span>
          <span><Editable value={empresa?.tamano} onSave={(v) => guardar("tamano", v)} testid="tamano" /> personas</span>
          <span className="text-borde">·</span>
          <Editable value={empresa?.pais || empresa?.ciudad || "tu país"} onSave={(v) => guardar("pais", v)} testid="pais" />
        </div>

        <p className="text-gris text-sm mb-12">Si algo de esto no está bien, tocá y corregilo.</p>

        <button className="btn-dorado" onClick={() => nav("/boot")} data-testid="empecemos">EMPECEMOS</button>
      </motion.div>
    </div>
  );
}
